
<!-- component that shows chat attributes to doctor at chat list -->
<template>
  <router-link class="message-item flex space-between items-center border-top border-gray-5 py1 px2" active-class="active" :to="createLinkTo({chatId: chat.chatId})">
    <div class="pr2 flex-none">
      <div v-if="chat.pet.imageId && !hideAvatar" class="avatar circle" width="30" height="30" :title="chat.name" v-bind:style="{backgroundImage: 'url(' + petImageUrl+ ')'}"></div>
      <div v-else class="avatar circle bg-blue"></div>
    </div>
    <div class="flex-auto h5">
      <div class="bold" v-if="profile.admin && ['own', 'closed'].includes(chat.queue)">{{getName()}}</div>
      <div class="semibold" v-if="appointment">{{appointment.clinicName || 'Klinikan nimeä ei saatavilla'}}</div>
      <div class="semibold">{{petNickname}} <img v-if="chat.locale === 'sv'" src="/favicon/SWE_lippu.svg" /></div>
      <div class="name">{{species}}, {{getAge()}}</div>
    </div>
    <UnseenMessagesIndicator v-if="unseenMessages" class="flex-none mr1" :unseenMessages="unseenMessages" />
    <div v-if="!chat.closedAt" class="flex-none center line-height-1 flex gray-3" v-bind:class="{ red: isResponseTimeOverdue() }">
      <div v-if="hours > 0">
        <div class="h2">{{hours}}</div>
        <div class="h5">h</div>
      </div>
      <div class="ml1">
        <div class="h2">{{minutes}}</div>
        <div class="h5">min</div>
      </div>
    </div>
    <div v-else>
      <div>{{closedAt}}</div>
    </div>
  </router-link>
</template>

<script>
import { mapGetters } from "vuex";
import UnseenMessagesIndicator from "@/components/reception/UnseenMessagesIndicator.vue";
import Util from '@/util';

export default {
    name: 'ListItem',
    components: {
      UnseenMessagesIndicator,
    },
    props: {
      chat: Object,
      createLinkTo: Function,
      hideAvatar: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        minutes: 0,
        hours: 0,
        closedAt: '',
      }
    },
    computed: {
      petImageUrl() {
          return Util.getPetImageURL(this.chat);
      },
      petNickname() {
        return this.chat.pet.nickname || this.chat.pet.name;
      },
      species() {
        return Util.mapSpecies(this.chat.pet.species);
      },
      appointment() {
        const appointments = this.chat.appointments || [];
        return appointments[appointments.length - 1];
      },
      unseenMessages() {
        return this.chatUnseenMessagesById(this.chat.chatId);
      },
      ...mapGetters({
        profile: 'profile',
        chatUnseenMessagesById: 'chatUnseenMessagesById',
      }),
    },
    mounted() {
      this.calcTime()
      this.waitTime()
    },
    methods: {
      getName() {
        if(this.chat.practitioners[0]) {
          return 'EL: ' + this.chat.practitioners[this.chat.practitioners.length-1].name;
        }
      },
      isResponseTimeOverdue() {
        switch (this.chat.queue) {
          case 'new':
            return this.hours >= 1 || this.minutes > 5;

          case 'appointment':
            return this.hours >= 1;

          default:
            return false;
        }
      },
      waitTime() {
        if(this.chat.closedAt) {
          const dateClosed = new Date(this.chat.closedAt);
          this.closedAt = dateClosed.getDate()+'.'+(dateClosed.getUTCMonth()+1)+'.'+dateClosed.getFullYear();
        } else {
         setInterval(() =>this.calcTime(), 1234);
        }
      },
      calcTime() {
        let waitTime = "";
        waitTime = (new Date()).getTime()-(new Date(this.chat.createdAt)).getTime();
        this.minutes = Math.floor((waitTime/1000/60));
        this.hours = Math.floor(this.minutes/60)
        this.minutes = this.minutes % 60;
      },
      getAge() {
        if(this.chat.pet.birthdate) {
          const unixAge = (new Date()).getTime()-(new Date(this.chat.pet.birthdate)).getTime();
          const age = new Date(unixAge)
          const years = Math.abs(age.getUTCFullYear() - 1970);
          const months = Math.abs(age.getUTCMonth());
          return `${years}v ${months}kk`;
        } else {
          return 'Ikä ei tiedossa';
        }
      },
    },
  };

</script>

<style scoped>

  .message-item {
    color: var(--dark-blue);
    text-decoration: none;
  }

  .message-item:hover {
    background-color: var(--gray);
  }

  .active {
    background-color: var(--white);
    border-top: 1px solid #00A1D4;
    box-shadow: inset 0 -1px 0 #00A1D4;
  }

  .active:hover {
    background-color: var(--white);
  }

  .avatar {
    width: 2rem;
    height: 2rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

</style>
